<template>
    <Card title="Datos legales">
        <div class="tw:space-y-4">
            <ToggleSwitch
                data-cy="privacidad"
                :value="!!abonado.privacidad"
                disabled
            >
                Acepta política de privacidad
                <span class="tw:font-normal tw:text-gray-400">(No editable)</span>
            </ToggleSwitch>

            <ToggleSwitch
                data-cy="condiciones"
                :value="!!abonado.condiciones"
                disabled
            >
                Acepta condiciones de uso
                <span class="tw:font-normal tw:text-gray-400">(No editable)</span>
            </ToggleSwitch>

            <ToggleSwitch
                data-cy="comunicaciones"
                :value="datosLocales.comunicaciones"
                @input="datosLocales.comunicaciones = $event"
            >
                Acepta recibir comunicaciones comerciales
            </ToggleSwitch>

            <ToggleSwitch
                v-if="abonado.plazos && abonado.plazos.length > 0"
                :value="datosLocales.condiciones_plazos"
                @input="datosLocales.condiciones_plazos = $event"
            >
                Acepta condiciones de pago en plazos
            </ToggleSwitch>

            <div class="tw:flex tw:justify-end tw:mt-6 tw:pt-4 tw:border-t tw:border-gray-200">
                <Button
                    @click="guardarDatos"
                    :disabled="!ha_cambiado"
                    class="tw:text-xs tw:sm:text-sm"
                >
                    Guardar datos legales
                </Button>
            </div>
        </div>
    </Card>
</template>

<script setup>
    import { ref, computed, watch } from 'vue'
    import Card from '@/modules/admin/ui/Card.vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue'

    const props = defineProps({
        abonado: {
            type: Object,
            required: true
        }
    })

    const emit = defineEmits(['editar-datos-legales'])

    const datosLocales = ref({
        comunicaciones: Boolean(props.abonado?.comunicaciones),
        condiciones_plazos: Boolean(props.abonado?.condiciones_plazos)
    })

    watch(
        () => [props.abonado?.comunicaciones, props.abonado?.condiciones_plazos],
        ([com, cond]) => {
            datosLocales.value.comunicaciones = Boolean(com)
            datosLocales.value.condiciones_plazos = Boolean(cond)
        }
    )

    const ha_cambiado = computed(() => {
        return (
            datosLocales.value.comunicaciones !== Boolean(props.abonado?.comunicaciones) ||
            datosLocales.value.condiciones_plazos !== Boolean(props.abonado?.condiciones_plazos)
        )
    })

    function guardarDatos() {
        emit('editar-datos-legales', datosLocales.value)
    }
</script>
